import React from "react";
import { useIntl } from "react-intl";
import { ArrowCounterclockwise20Filled } from "@fluentui/react-icons";
import { Tooltip } from "@fluentui/react-components";
import PropTypes from "prop-types";

export function ResetButton({ onClick }) {
  const intl = useIntl();

  const handleClick = e => {
    e.stopPropagation();
    onClick();
  };

  return (
    <Tooltip
      content={intl.formatMessage({
        id: "room-settings-sidebar.reset-to-default",
        defaultMessage: "Reset settings to default"
      })}
      positioning="above"
      trigger="click"
    >
      <span
        type="button"
        aria-label={intl.formatMessage({
          id: "room-settings-sidebar.reset-to-default",
          defaultMessage: "Reset settings to default"
        })}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer"
        }}
        onClick={handleClick}
      >
        <ArrowCounterclockwise20Filled />
      </span>
    </Tooltip>
  );
}

ResetButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
